import { render, staticRenderFns } from "./NavBarConnections.vue?vue&type=template&id=f819e15a"
import script from "./NavBarConnections.vue?vue&type=script&lang=js"
export * from "./NavBarConnections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports